import { render, staticRenderFns } from "./void.vue?vue&type=template&id=1a4a0f27&scoped=true&"
import script from "./void.vue?vue&type=script&lang=js&"
export * from "./void.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4a0f27",
  null
  
)

export default component.exports